var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 10.6111V11.3333C4.25 11.6179 4.3082 11.8996 4.42127 12.1625C4.53435 12.4253 4.70008 12.6642 4.90901 12.8654C5.11798 13.0666 5.366 13.2262 5.63893 13.335C5.91193 13.444 6.2045 13.5 6.5 13.5C6.7955 13.5 7.08807 13.444 7.36107 13.335C7.634 13.2262 7.88202 13.0666 8.09097 12.8654C8.29992 12.6642 8.46567 12.4253 8.5787 12.1625C8.6918 11.8996 8.75 11.6179 8.75 11.3333V10.6111M11 4.83333C11 7 12.5 10.6111 12.5 10.6111H0.5C0.5 10.6111 2 7.72222 2 4.83333C2 2.47311 4.049 0.5 6.5 0.5C8.951 0.5 11 2.47311 11 4.83333Z",
    stroke: "#7E7E7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.bb9e0f343779177b4755b0fd965d3d55.svg";
export { ForwardRef as ReactComponent };